import axios from 'axios';
import propertyPaths from '../paths';
import { ICollateralPropertyLoginResponse } from '../login/types';
import endpoints from './endpoints';

// ----------------------------------------------------------------------

const axiosConfig = {
  baseURL: process.env.REACT_APP_CORE_API_URL,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    Accept: 'application/json',
    'Content-Type': 'application/json',
    // Authorization: `Bearer ${localStorage.getItem('propertyAccessToken')}`,
  },
  timeout: 0,
};

const axiosInstance = axios.create(axiosConfig);

// refresh token
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const refreshToken = localStorage.getItem('propertyRefreshToken');
      const accessToken = localStorage.getItem('propertyAccessToken');
      if (
        refreshToken &&
        accessToken &&
        originalRequest.url !== endpoints.agentNetworkService.auth.refresh
      ) {
        try {
          const res = await axiosInstance.post(
            endpoints.agentNetworkService.auth.refresh,
            {
              accessToken,
              refreshToken,
            }
          );
          const resData: ICollateralPropertyLoginResponse = res.data;
          if (
            res.status === 201 &&
            resData.accessToken &&
            resData.refreshToken
          ) {
            const newAccessToken = resData.accessToken;
            const newRefreshToken = resData.refreshToken;

            localStorage.setItem('propertyAccessToken', newAccessToken);
            localStorage.setItem('propertyRefreshToken', newRefreshToken);

            originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
            originalRequest.headers['Refresh-Token'] = newRefreshToken;
            axiosInstance.defaults.headers.Authorization = `Bearer ${newAccessToken}`;
            axiosInstance.defaults.headers['Refresh-Token'] = newRefreshToken;
            return await axiosInstance(originalRequest);
          }
        } catch (refreshError) {
          console.error('Refresh token failed', refreshError);
          localStorage.removeItem('propertyAccessToken');
          localStorage.removeItem('propertyRefreshToken');
          localStorage.removeItem('propertyProfile');
          window.location.href = propertyPaths.login;
        }
      }
      // Если нет refresh токена, он не сработал или это запрос на рефреш перенаправляем на страницу входа
      console.error('Refresh token failed');
      localStorage.removeItem('propertyAccessToken');
      localStorage.removeItem('propertyRefreshToken');
      localStorage.removeItem('propertyProfile');
      window.location.href = propertyPaths.login;
    }
    return Promise.reject(
      (error.response && error.response.data) || 'Что-то пошло не так'
    );
  }
);

export default axiosInstance;
